// Composite frame source that bundles face + hands + pose into one InputFrame
// for the runner. Microgames consume the bundle directly; they don't care
// which trackers are running.

import { type InputFrame, type FrameSource } from '@pose-game/core';
import type { Camera } from './camera.js';
import type { FaceTracker } from './face.js';
import type { HandsTracker } from './hands.js';
import type { PoseTracker } from './pose.js';

export interface AggregateOptions {
  camera: Camera;
  face: FaceTracker;
  hands: HandsTracker;
  pose: PoseTracker;
}

export class AggregateFrameSource implements FrameSource {
  constructor(private opts: AggregateOptions) {}

  getFrame(): InputFrame {
    const { camera, face, hands, pose } = this.opts;
    return {
      timestamp: performance.now(),
      videoWidth: camera.width,
      videoHeight: camera.height,
      face: face.lastFrame,
      hands: hands.lastFrame,
      pose: pose.lastFrame,
    };
  }
}
